// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__84T49"};